var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetaAnalysisGene(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 516.1 352.6",
    style: {
      enableBackground: "new 0 0 516.1 352.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8C1515;stroke:#8C1515;stroke-miterlimit:10;}\n\t.st1{fill:#F9C002;stroke:#F9C002;stroke-width:0.84;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.st4{fill:#2094E8;stroke:#2094E8;stroke-width:5;stroke-miterlimit:10;}\n\t.st5{font-family:'Helvetica-Bold';}\n\t.st6{font-size:22.246px;}\n\t\n\t\t.st7{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:6,12;}\n\t.st8{font-size:21.4221px;}\n\t.st9{fill:#56BF46;stroke:#56BF46;stroke-width:1.36;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.1,
    y: 31.8,
    className: "st0",
    width: 31.3,
    height: 31.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 160.9,
    className: "st1",
    width: 22.2,
    height: 31.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 266.4,
    y1: 47.4,
    x2: 348.8,
    y2: 47.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 235.1,
    y1: 47.4,
    x2: 172.5,
    y2: 47.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 431.2,
    y1: 106,
    x2: 513.6,
    y2: 106
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 309.3,
    y1: 176.5,
    x2: 338.9,
    y2: 176.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 287,
    y1: 176.5,
    x2: 257.4,
    y2: 176.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 462.5,
    y1: 106,
    x2: 399.9,
    y2: 106
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "248.3,302.8 354.6,349.8 441.9,302.8 354.6,255.9  "
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 115.6751 335.0768)",
    className: "st5 st6"
  }, "0"), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 120.2,
    y1: 2.5,
    x2: 121.8,
    y2: 302.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 2.5,
    y1: 229.1,
    x2: 513.6,
    y2: 229.1
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1.6145 112.9796)",
    className: "st5 st8"
  }, "GSE12345"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1.6145 54.3897)",
    className: "st5 st8"
  }, "GSE12345"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1.6145 180.8297)",
    className: "st5 st8"
  }, "GSE12345"), /*#__PURE__*/React.createElement("rect", {
    x: 413.1,
    y: 90.8,
    className: "st9",
    width: 59.3,
    height: 30.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaAnalysisGene);
export default __webpack_public_path__ + "static/media/MetaAnalysisGene.0747b83383c5e9cc1d6d7da136119041.svg";
export { ForwardRef as ReactComponent };